export default "__VITE_ASSET__0aa501f8__"